import { isBrowserEnvironment } from './isBrowserEnvironment';

const GTAG_SRC = 'https://www.googletagmanager.com/gtag/js';
const ANALYTICS_SCRIPT_ATTRIBUTE = 'data-cookie-consent-analytics';

const CONSENT_AFTER_OPT_IN = {
    analytics_storage: 'granted',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
};

function hasLoadedAnalytics(measurementId) {
    return document.querySelector(`script[${ANALYTICS_SCRIPT_ATTRIBUTE}="${measurementId}"]`) !== null;
}

function getDisableFlag(measurementId) {
    return `ga-disable-${measurementId}`;
}

function ensureGtag() {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
        window.gtag = function gtag() {
            window.dataLayer.push(arguments);
        };
    }
}

function loadAnalytics(measurementId) {
    ensureGtag();
    window.gtag('consent', 'default', CONSENT_AFTER_OPT_IN);
    window.gtag('js', new Date());
    window.gtag('config', measurementId);

    const script = document.createElement('script');
    script.async = true;
    script.src = `${GTAG_SRC}?id=${encodeURIComponent(measurementId)}`;
    script.setAttribute(ANALYTICS_SCRIPT_ATTRIBUTE, measurementId);
    document.head.appendChild(script);
}

// Every change to the analytics choice reloads the page first, so granting only ever
// happens on a fresh page where Google Analytics is not loaded yet. Whether it is loaded is
// decided by our own script tag, so a gtag defined by the host page does not count.
export function setAnalyticsConsent(measurementId, isGranted) {
    if (!isBrowserEnvironment() || !measurementId) {
        return;
    }

    if (isGranted) {
        if (!hasLoadedAnalytics(measurementId)) {
            loadAnalytics(measurementId);
        }
        return;
    }

    if (hasLoadedAnalytics(measurementId)) {
        window[getDisableFlag(measurementId)] = true;
        window.gtag('consent', 'update', { analytics_storage: 'denied' });
    }
}
